<template>
  <el-container class="home2-c" :style="{ height: '100dvh' }">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="sidebar"
      :class="{ 'mobile-open': isMobile && !isCollapse, 'is-collapsed': isCollapse }">
      <!-- Logo -->
      <div class="sidebar-logo" @click="isCollapse = !isCollapse">
        <el-image style="width: 32px;height: 32px;" :src="require('@/assets/img/qhy2.png')"></el-image>
        <span class="logo-text" :class="{ 'text-hidden': isCollapse }">{{ $siteConfig.siteName }}</span>
      </div>

      <!-- 菜单 -->
      <el-menu :default-active="activePath" :collapse="isCollapse" :collapse-transition="false" class="sidebar-menu"
        background-color="#f8fafc" text-color="#64748b" active-text-color="#1a73e8" router>
        <el-menu-item index="/user2/index" @click="saveNav('/user2/index', '首页')">
          <app-icon  class="app-icon" name="home"></app-icon>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/user2/custom" @click="saveNav('/user2/custom', '自由工作台')">
          <app-icon  class="app-icon" name="dashboard_customize"></app-icon>
          <span slot="title">自由工作台</span>
        </el-menu-item>
        <el-menu-item index="/user2/record" @click="saveNav('/user2/record', '制作记录')">
          <app-icon  class="app-icon" name="history"></app-icon>
          <span slot="title">制作记录</span>
        </el-menu-item>
        <div v-if="!isCollapse" class="menu-group-label">创作工具</div>
        <el-menu-item class="menu-item-detailed" index="/user2/qc" @click="saveNav('/user2/qc', '视频去重')">
          <app-icon  class="app-icon" name="content_cut"></app-icon>
          <span slot="title">视频去重<small class="menu-item-hint">模式与预设</small></span>
        </el-menu-item>
        <el-menu-item class="menu-item-detailed" index="/user2/qcai" @click="saveNav('/user2/qcai', '视频去重 V2')">
          <app-icon  class="app-icon" name="auto_fix_high"></app-icon>
          <span slot="title">视频去重 V2<small class="menu-item-hint">二创特效</small></span>
        </el-menu-item>
        <el-menu-item class="menu-item-detailed" index="/user2/hj" @click="saveNav('/user2/hj', '视频混剪')">
          <app-icon  class="app-icon" name="movie_edit"></app-icon>
          <span slot="title">视频混剪<small class="menu-item-hint">模式与附加选项</small></span>
        </el-menu-item>
        <el-menu-item class="menu-item-detailed" index="/user2/hj2" @click="saveNav('/user2/hj2', '视频混剪 V2')">
          <app-icon  class="app-icon" name="video_settings"></app-icon>
          <span slot="title">视频混剪 V2<small class="menu-item-hint">高级时长控制</small></span>
        </el-menu-item>
        <el-menu-item index="/user2/qsy" @click="saveNav('/user2/qsy', '提取视频')">
          <app-icon  class="app-icon" name="download"></app-icon>
          <span slot="title">提取视频</span>
        </el-menu-item>
        <el-menu-item index="/user2/qzm" @click="saveNav('/user2/qzm', '视频去字幕')">
          <app-icon  class="app-icon" name="text_fields"></app-icon>
          <span slot="title">视频去字幕</span>
        </el-menu-item>
        <el-menu-item index="/user2/watermark" @click="saveNav('/user2/watermark', '图片去水印')">
          <app-icon  class="app-icon" name="broken_image"></app-icon>
          <span slot="title">图片去水印</span>
        </el-menu-item>
        <div v-if="!isCollapse" class="menu-group-label">素材与记录</div>
        <el-menu-item index="/user2/haowu" @click="saveNav('/user2/haowu', '聚合好物')">
          <app-icon  class="app-icon" name="shopping_bag"></app-icon>
          <span slot="title">聚合好物</span>
        </el-menu-item>
        <el-menu-item index="/user2/ku" @click="saveNav('/user2/ku', '混剪协同')">
          <app-icon  class="app-icon" name="inbox"></app-icon>
          <span slot="title">混剪协同</span>
        </el-menu-item>
        <el-menu-item index="/user2/upload_tutorial" @click="saveNav('/user2/upload_tutorial', '教程设置')">
          <app-icon class="app-icon" name="menu_book"></app-icon>
          <span slot="title">教程设置</span>
        </el-menu-item>
        <div v-if="!isCollapse" class="menu-group-label">账户服务</div>
        <el-menu-item index="/user2/info" @click="saveNav('/user2/info', '用户信息')">
          <app-icon  class="app-icon" name="manage_accounts"></app-icon>
          <span slot="title">我的信息</span>
        </el-menu-item>
        <el-menu-item index="/user2/share" @click="saveNav('/user2/share', '分享好友')">
          <app-icon  class="app-icon" name="group_add"></app-icon>
          <span slot="title">分享好友</span>
        </el-menu-item>
        <el-menu-item index="/user2/vip" @click="saveNav('/user2/vip', '购买会员')">
          <app-icon  class="app-icon" name="workspace_premium"></app-icon>
          <span slot="title">购买会员</span>
        </el-menu-item>
        <el-menu-item index="/user2/developer" @click="saveNav('/user2/developer', '代理后台')">
          <app-icon  class="app-icon" name="admin_panel_settings"></app-icon>
          <span slot="title">代理后台</span>
        </el-menu-item>
        <el-menu-item v-if="hasCdkAuth" index="/buy-cdk" @click="saveNav('/buy-cdk', '兑换码')">
          <app-icon  class="app-icon" name="redeem"></app-icon>
          <span slot="title">兑换码</span>
        </el-menu-item>
        <el-menu-item index="/user2/api-key" @click="saveNav('/user2/api-key', 'API 开放平台')">
          <app-icon class="app-icon" name="key"></app-icon>
          <span slot="title">API 开放平台</span>
        </el-menu-item>
        <div class="menu-divider"></div>
        <button type="button" class="sidebar-version" title="切换旧版1.0" @click="switchToV1">
          <app-icon class="app-icon" name="arrow_back"></app-icon>
          <span :class="{ 'text-hidden': isCollapse }">切换旧版1.0</span>
        </button>
        <button type="button" class="sidebar-logout" @click="outuser">
          <app-icon class="app-icon" name="logout"></app-icon>
          <span :class="{ 'text-hidden': isCollapse }">退出登录</span>
        </button>
      </el-menu>
    </el-aside>
    <div v-if="isMobile && !isCollapse" class="mobile-menu-mask" @click="isCollapse = true"></div>

    <!-- 内容区 -->
    <el-container class="content-container">
      <!-- Header -->
      <el-header class="page-header">
        <div class="header-left">
          <div class="collapse-btn" @click="isCollapse = !isCollapse">
            <app-icon  class="app-icon" :name="isCollapse ? 'menu' : 'menu_open'"></app-icon>
          </div>
          <span class="page-name">{{ currentPageName }}</span>
        </div>
        <div class="header-right">
          <div class="header-points" @click="$router.push('/user2/info')">
            <app-icon  class="app-icon" name="bolt"></app-icon>
            <span>可用 {{ availablePoints }}</span>
          </div>
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-user">
              <app-icon class="app-icon" name="person"></app-icon>
              <span class="account-name">{{ currentAccount }}</span>
              <i class="el-icon-arrow-down account-dropdown-arrow"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info" icon="el-icon-user">账户信息</el-dropdown-item>
              <el-dropdown-item command="logout" icon="el-icon-switch-button" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- Main -->
      <el-main class="page-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { clearUserProfile, getUserProfile } from '@/config/userProfile'

export default {
  name: 'Home2',
  data() {
    return {
      activePath: '/user2/index',
      currentPageName: '首页',
      isCollapse: false,
      isMobile: false,
      phone: '****',
      username: '',
      availablePoints: 0,
      hasCdkAuth: window.localStorage.getItem('cdk_auth') === '1'
    }
  },
  watch: {
    '$route.path': {
      handler(path) {
        this.activePath = path
        const pageNames = {
          '/user2/index': '首页',
          '/user2/info': '我的信息',
          '/user2/vip': '购买会员',
          '/user2/custom': '自由工作台',
          '/user2/qc': '视频去重',
          '/user2/qcai': '视频去重 V2',
          '/user2/hj': '视频混剪',
          '/user2/hj2': '视频混剪 V2',
          '/user2/qsy': '提取视频',
          '/user2/qzm': '视频去字幕',
          '/user2/watermark': '图片去水印',
          '/user2/haowu': '聚合好物',
          '/user2/ku': '混剪协同',
          '/user2/record': '制作记录',
          '/user2/upload_tutorial': '教程设置',
          '/user2/tutorial_edit': '教程设置',
          '/user2/share': '分享好友',
          '/user2/developer': '代理后台',
          '/user2/api-key': 'API 开放平台',
          '/user2/api-docs': 'API 接口文档'
        }
        this.currentPageName = pageNames[path] || '首页'
      },
      immediate: true
    }
  },
  computed: {
    currentAccount() {
      const phone = String(this.phone || '').trim()
      return phone && !/^\*+$/.test(phone) ? phone : (this.username || '—')
    }
  },
  methods: {
    saveNav(path, name) {
      this.activePath = path
      this.currentPageName = name
    },
    switchToV1() {
      this.$router.push('/user/index')
    },
    handleAccountCommand(command) {
      if (command === 'info') {
        this.$router.push('/user2/info')
      } else if (command === 'logout') {
        this.outuser()
      }
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) this.isCollapse = true
    },
    getUserInfo() {
      getUserProfile(this.$ajax).then(data => {
        if (data) {
          this.phone = data.phone || ''
          this.username = data.username || ''
          this.availablePoints = data.available_points || 0
        }
      }).catch(() => { })
    },
    getCdkAuth() {
      this.$ajax.get('api/v1/proxy/cdks/sellers').then(res => {
        const list = (res.data && res.data.data) || []
        this.hasCdkAuth = list.length > 0
        window.localStorage.setItem('cdk_auth', this.hasCdkAuth ? '1' : '0')
      }).catch(() => {
        this.hasCdkAuth = false
      })
    },
    outuser() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('cdk_auth')
        clearUserProfile()
        this.$router.push('/login')
      }).catch(() => { })
    }
  },
  created() {
    this.getUserInfo()
    this.getCdkAuth()
  },
  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport)
  }
}
</script>

<style scoped>
.home2-c {
  overflow: hidden;
}

/* 侧边栏 */
.sidebar {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease;
  will-change: width;
  overflow: hidden;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 56px;
  cursor: pointer;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  overflow: hidden;
}

.logo-text {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 700;
  color: #1a73e8;
  white-space: nowrap;
  transition: opacity 0.25s ease, visibility 0.25s ease, max-width 0.25s ease;
}

.sidebar-logout span:not(.app-icon),
.sidebar-version span:not(.app-icon) {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease, max-width 0.25s ease;
}

.text-hidden {
  opacity: 0;
  visibility: hidden;
  max-width: 0 !important;
}

.sidebar-menu {
  flex: 1;
  border-right: none;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sidebar-menu::-webkit-scrollbar {
  display: none;
}

/* 侧边栏底部两个动作（切换旧版 / 退出登录）共用同一套几何 */
.sidebar-logout,
.sidebar-version {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  height: 40px;
  width: calc(100% - 16px);
  margin: 4px 8px 8px;
  padding: 0 20px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  transition: all .2s ease;
}

/* 切换旧版紧贴退出登录上方，两个按钮之间不留大缝 */
.sidebar-version {
  margin-bottom: 0;
}

.sidebar-logout:hover,
.sidebar-version:hover {
  background: #e3f2fd;
  color: #1a73e8;
}

.sidebar-logout .app-icon,
.sidebar-version .app-icon {
  margin-right: 8px;
  font-size: 18px;
}

.sidebar-menu .el-menu-item {
  margin: 4px 8px;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar-menu .el-menu-item .app-icon {
  margin-right: 8px;
  font-size: 18px;
  vertical-align: -3px;
}

.sidebar-menu .el-menu-item span {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.sidebar-menu .el-menu-item:hover {
  background: #e3f2fd !important;
}

.sidebar-menu .el-menu-item.is-active {
  background: #e3f2fd !important;
  color: #1a73e8 !important;
  font-weight: 600;
}

.menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 8px 16px;
}

/* 内容区 */
.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 56px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.collapse-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.collapse-btn:hover {
  background: #f1f5f9;
}

.collapse-btn .app-icon {
  font-size: 22px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.page-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  line-height: 36px;
  margin-top: -4px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #f1f5f9;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.header-user:hover {
  background: #e2e8f0;
}

.header-user .app-icon {
  font-size: 18px;
  color: #1a73e8;
}

.header-user .account-name {
  font-size: 13px;
  color: #1e293b;
}

.account-dropdown-arrow {
  margin-left: 2px;
  color: #94a3b8;
  font-size: 12px;
}

.header-points {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 11px;
  border: 1px solid #dbeafe;
  border-radius: 20px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all .2s;
}

.header-points:hover {
  background: #dbeafe;
}

.header-points .app-icon {
  font-size: 16px;
}

@media (max-width: 768px) {
  .sidebar { position: fixed; top: 0; bottom: 0; left: 0; z-index: 101; height: 100dvh !important; transform: translateX(-100%); box-shadow: 12px 0 30px rgba(15, 23, 42, .16); transition: transform 0.3s ease, width 0.35s cubic-bezier(0.4, 0, 0.2, 1); }
  .sidebar.mobile-open { transform: translateX(0); }
  .mobile-menu-mask { position: fixed; z-index: 100; inset: 0; background: rgba(15, 23, 42, .28); }
  .page-header { padding: 0 10px; }
  .header-left { gap: 6px; min-width: 0; }
  .page-name { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 0; }
  .header-right { flex-shrink: 0; gap: 6px; }
  .header-user { gap: 4px; padding: 6px 9px; }
  .header-points { gap: 3px; padding: 6px 8px; }
}

@media (max-width: 480px) {
  .header-user .app-icon { display: none; }
  .header-user { padding: 6px 8px; }
  .header-points { padding: 6px 7px; }
}

@media (max-width: 360px) {
  .page-name { display: none; }
}

/* Main */
.page-main {
  background: #f5f7fa;
  padding: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.menu-group-label { padding:18px 24px 6px; font-size:11px; color:#94a3b8; letter-spacing:.08em; }
.menu-item-hint { display:block; font-size:10px; line-height:14px; font-weight:400; color:#94a3b8; }
.sidebar-menu:not(.el-menu--collapse) .el-menu-item.menu-item-detailed { height:54px; line-height:22px; display:flex; align-items:center; }
.home2-c /deep/ .tool-content, .home2-c /deep/ .info2-content { max-width:1100px; }
.home2-c /deep/ .ku-page .tool-content { max-width:none; }
.home2-c /deep/ .tool-heading h2, .home2-c /deep/ .page-heading h2 { font-size:24px; color:#0f172a; }
.home2-c /deep/ .tool-heading p, .home2-c /deep/ .page-heading p { color:#64748b; line-height:1.6; }
.home2-c /deep/ .tool-card { border-radius:16px; box-shadow:0 4px 16px rgba(15,23,42,.03); }
@media(max-width:768px) {
 .home2-c /deep/ .tool-page { padding:18px 14px 28px; }
 .home2-c /deep/ .tool-card { padding:16px; }
 .home2-c /deep/ .tool-heading h2, .home2-c /deep/ .page-heading h2 { font-size:22px; }
}
</style>

<style>
/* 折叠侧边栏 — 菜单图标居中 + 文字平滑隐藏 */
.home2-c .el-menu--collapse .el-menu-item {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.home2-c .el-menu--collapse .el-menu-item .el-tooltip {
  padding-left: 0 !important;
  padding-right: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.home2-c .el-menu--collapse .el-menu-item .el-tooltip > div {
  padding: 0 !important;
}

.home2-c .el-menu--collapse .el-menu-item i {
  margin-right: 0;
  width: 100%;
  text-align: center;
}

.home2-c .el-menu--collapse .el-menu-item .app-icon {
  margin-right: 0;
  width: 100%;
  height: auto;
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  visibility: visible;
  overflow: visible;
}

.home2-c .el-menu--collapse .el-menu-item span:not(.app-icon) {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/User2/Home.vue